import React from "react";

import { Card,  Badge } from "reactstrap";
import { Link } from 'react-router-dom';


import { Avatar } from 'alumni-components/Avatar/Avatar';

var Utils = require ('Utils');
var Const = require ('Const');

export const StudentCard = ( props ) => { 

    let {
        persona,
        showCourse
      } = props;


    return (
        <>
        {persona && 
            <Card className="card-user">
                <div className="image">
                  <img
                    alt="..."
                    src={require("img/student-badge-back2.jpg")}
                  />
                </div>
                <div className="author">
                <Link to={"/admin/students/"+persona.persona_id}>
                  <Avatar 
                    src={persona.image?persona.image:Const.DEFAULT_IMAGE_PROFILE[(persona.gender?persona.gender:'O')]}
                  />
                    <p className="h5">
                      {Utils.capitalize(persona.last_name + ", " + persona.name)}
                    </p>
                  </Link>
                  { persona.tags && persona.tags.map( tag => {
                     return ( 
                        <Badge style={{ backgroundColor: "#"+ tag.tag_color }}>{tag.tag_label}</Badge>
                     )
                    }) }
                  

                  {showCourse && 
                     <p> {persona.course_name}</p>
                    }
                </div>
                
              </Card>
            }
        </>
    );
  }


// export default StudentCard ;